<template>

    <div class="step-content">
        <div class="intro-block">
            <h5 class="txt-grt">Look & feel</h5>
            <p>Customize your platform. Take inspiration in our presets or let your imagination roam free.</p>
        </div>
        <div class="step-inner-content">

            <ToggleWrapper caption="Presets" :items="['Custom', 'Sport', 'Entertainment', 'Lifestyle']" noshrink
                @input="onPresetChange"
            ></ToggleWrapper>

            <div class="split-content">
                <Uploader caption="Logo" class="logo" @preview-change="onLogoPreviewChange" ref="uploader-logo"></Uploader>
                <Uploader caption="Background" class="bg" @preview-change="onBackgroundPreviewChange" ref="uploader-background"></Uploader>
            </div>
            
            <PickerWrapper uniqueClass="a" caption="Accent color" ref="picker-accent"
                v-model="Global.mockupConfig.colors.icons">
            </PickerWrapper>

            <FontsWrapper caption="Typography" :fonts="selectedFonts"></FontsWrapper>

            <ToggleWrapper tempDelay caption="Menu location" :items="['Left', 'Top']"
                v-model="Global.mockupConfig.topNav" @tempDisable="noTrans">
            </ToggleWrapper>

            <ToggleWrapper caption="Card orientation" :items="['Horizontal', 'Vertical']" 
                v-model="Global.mockupConfig.verticalNav">
            </ToggleWrapper>

            <SliderWrapper caption="Corner radius" @updateSlider="updateBorderRadius"></SliderWrapper>

            <div class="nxt-out">
                <div class="bgout"></div>
                <router-link tag="div" to="/model" class="btn bck">
                    <span class="txt">Back</span>
                </router-link>
                <router-link tag="div" to="/services" class="btn main txt-blk">
                    <span class="hvr"></span>
                    <span class="txt">Continue</span>
                </router-link>
            </div>
        </div>
    </div>

</template>

<script>

    import Global from '../../lib/GlobalState'
    import Uploader from '../../components/Uploader'
    import ToggleWrapper from '../../components/ToggleWrapper'
    import PickerWrapper from '../../components/PickerWrapper'
    import FontsWrapper from '../../components/FontsWrapper'
    import SliderWrapper from '../../components/SliderWrapper'

    export default {

        name: 'D',

        components: {
            Uploader,
            ToggleWrapper,
            PickerWrapper,
            FontsWrapper,
            SliderWrapper
        },

        data() {
            return {
                Global,
                selectedFonts: [
                    { caption: 'Roboto Slab', className: 'ft-roboto' },
                    { caption: 'Raleway', className: 'ft-raleway' },
                    { caption: 'Oswald', className: 'ft-oswald' },
                    { caption: 'Lora', className: 'ft-lora' }
                ],
            }
        },

        methods: {

            onPresetChange(e) {
                
                const assets = [
                    ["/img/presets/sport.svg", "/img/presets/bg_sport.jpg", "#34BF31"],
                    ["/img/presets/entertainment.svg", "/img/presets/bg_entertainment.jpg", "#DE1C2E"],
                    ["/img/presets/lifestyle.svg", "/img/presets/bg_lifestyle.jpg", "#914FBF"],
                ]

                if(e === 0) {
                    this.$refs['uploader-logo'].clearPreviewSrc()
                    this.$refs['uploader-background'].clearPreviewSrc()
                    this.$refs['picker-accent'].setColor("#FEBC38")
                    return
                }

                this.$refs['uploader-logo'].setPreviewSrc(assets[e-1][0])
                this.$refs['uploader-background'].setPreviewSrc(assets[e-1][1])
                this.$refs['picker-accent'].setColor(assets[e-1][2])
            },

            onLogoPreviewChange(value) {
                this.Global.mockupConfig.pictures.logo = value
            },

            onBackgroundPreviewChange(value) {
                this.Global.mockupConfig.pictures.background = value
            },

            updateBorderRadius(value) {
                this.Global.mockupConfig.radiusRatio = value
            },

            noTrans() {
                this.Global.mockupConfig.tempNoTrans = true
                setTimeout(() => { this.Global.mockupConfig.tempNoTrans = false }, 200)
            }
        }
    }

</script>